<div class="tx-selection" *ngIf="count > 0">
  <span class="tx-selection-count">
    {{ count }} selected · {{ signed(total) }}
  </span>

  <div class="tx-selection-actions">
    <button type="button" class="sd-btn" (click)="clear.emit()">Clear</button>
    <button type="button" class="sd-btn" *ngIf="showCode && codeableCount > 0" (click)="code.emit()">
      Add coding<span class="tx-selection-sub" *ngIf="codeableCount !== count">
        ({{ codeableCount }})</span>
    </button>
    <button type="button" class="sd-btn" *ngIf="showSuggestCoding && codeableCount > 0"
            [disabled]="suggesting" (click)="suggestCoding.emit()"
            title="The Coding Assistant suggests an account and supplier for each, for you to confirm">
      {{ suggesting ? 'Suggesting…' : 'Suggest coding' }}<span class="tx-selection-sub" *ngIf="!suggesting && codeableCount !== count">
        ({{ codeableCount }})</span>
    </button>
    <button type="button" class="sd-btn" *ngIf="showAssign" [disabled]="busy" (click)="assign.emit()">Assign to</button>
    <button type="button" class="sd-btn" *ngIf="showRemoveFromReport" [disabled]="busy"
            (click)="removeFromReport.emit()">Remove from report</button>
    <button type="button" class="sd-btn sd-btn--primary" *ngIf="showAddToReport"
            (click)="addToReport.emit()">Add to report</button>
  </div>
</div>
